import { mods } from '@approvalmax/theme';
import { Menu } from '@approvalmax/ui/src/components';
import { StyledMods } from '@styled-kit/mods';
import styled, { css } from 'styled-components';

export const Root = styled(Menu.Item)<StyledMods<{ nestingLevel?: number }>>`
    ${mods('nestingLevel')(
        (value) => css`
            padding-left: ${(value ?? 0) * 8}px;
        `
    )}
`;
